import { Header } from '@/components/layout/Header';
import { PageBody } from '@/components/layout/PageBody';
import { WorkflowBuilder } from '@/components/workflows/WorkflowBuilder';
import { useProject } from '@/contexts/ProjectContext';

export function WorkflowBuilderPage(): React.ReactElement {
  const { selectedProjectId, codebases } = useProject();
  const codebase = codebases?.find(cb => cb.id === selectedProjectId);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Header title="Workflow Builder" projectName={codebase?.name} />
      <PageBody
        maxWidthClassName="max-w-[1600px]"
        className="overflow-hidden"
        contentClassName="h-full"
      >
        <div className="h-full overflow-hidden rounded-2xl border border-border/70 bg-surface/95 shadow-sm backdrop-blur-sm">
          <WorkflowBuilder />
        </div>
      </PageBody>
    </div>
  );
}
